import { http } from "./http";

export function get(url: string, data?: any): any {
    return http()({
        url: url,
        method: 'get',
        params: data
    })
}

export function post(url: string, data: any): any {
    return http()({
        url: url,
        method: 'post',
        data
    })
}

export function deleteAPi(url:string, data?: any): any{
    return http()({
        url: url,
        method: 'delete',
        data: data
    })
}